import { getFormattedStatus } from '@root/helpers/resources';
import clsx from 'clsx';

const statusColorMap: Record<string, string> = {
  /** Submissions */
  REVIEW: 'fill-red-500',
  FIRM_ORDER: 'fill-green-500',
  FINAL: 'fill-primary-500',
  /** Templates */
  PUBLISHED: 'fill-primary-500',
  /** Shared */
  ARCHIVED: 'fill-info-300',
  DRAFT: 'fill-yellow-500',
};

const getStatusColor = (status: string) => statusColorMap[status] ?? 'fill-info-300';

const StatusBadge = ({ className, status }: { className?: string; status: string }) => (
  <div className="inline-flex items-center">
    <span
      className={clsx(
        `inline-flex items-center gap-x-1.5 rounded-xl bg-white px-3 py-1 text-xs font-medium text-gray-900 ring-1 ring-gray-200 ring-inset`,
        className,
      )}
    >
      <svg className={`h-1.5 w-1.5 ${getStatusColor(status)}`} viewBox="0 0 6 6" aria-hidden="true">
        <circle cx={3} cy={3} r={3} />
      </svg>
      {getFormattedStatus(status)}
    </span>
  </div>
);

export default StatusBadge;
